module.exports = __webpack_public_path__ + "static/monday2-75643c849af07a6fcaa33bf59024bf47.png";